const keyAlgorithm = [
  'RSA',
  'EC',
  'sphincs+'
]

export default keyAlgorithm
